import {
  requestGet,
  requestGetForm,
  requestPost,
  requestPostForm,
} from "@/config/http-json";

const user = {
  async login(params = {}) {
    let response = await requestPostForm("/waveWriter/user/doLogin", params);
    return response;
  },
  async sendEmail(params = {}) {
    let response = await requestPostForm("/waveWriter/user/sendEmail", params);
    return response;
  },
  async verificationCode(params = {}) {
    let response = await requestGetForm("/waveWriter/user/verificationCode", params);
    return response;
  },
  async retrievePassword(params = {}) {
    let response = await requestPostForm("/waveWriter/user/retrievePassword", params);
    return response;
  },
  async registerBrandUser(params = {}) {
    let response = await requestPost("/waveWriter/user/registerBrandUser", params);
    return response;
  },
};

export default user;
